import { Text } from "@merge-api/merge-javascript-shared";
import ColumnCard from "./ColumnCard";
import { ArrowUp, ArrowDown, Minus } from "lucide-react";
import clsx from "clsx";

interface ComparisonRowProps {
  label: string;
  stagedValue?: number;
  publishedValue?: number;
  isAccordion?: boolean;
  isSubModel?: boolean;
}

const ComparisonRow = ({
  label,
  stagedValue,
  publishedValue,
  isAccordion = false,
  isSubModel = false,
}: ComparisonRowProps) => {
  const isPublishedGreaterThanStaged =
    publishedValue != null && stagedValue != null && stagedValue > publishedValue;

  const isEqual = publishedValue != null && stagedValue != null && publishedValue === stagedValue;

  return (
    <div
      className={clsx("items-start grid grid-cols-3 w-full", isAccordion ? "gap-8" : "gap-4 px-5")}
    >
      <ColumnCard isSubModel={isSubModel}>
        <Text as="div" variant="h6" className={clsx(isSubModel && "ml-3")}>
          {label}
        </Text>
      </ColumnCard>
      <ColumnCard isSubModel={isSubModel}>
        <Text as="div">{publishedValue}</Text>
      </ColumnCard>
      <ColumnCard isSubModel={isSubModel}>
        <div className="flex items-center flex-row -ml-1">
          {publishedValue != null &&
            stagedValue != null &&
            (isEqual ? (
              <Minus size={16} className="text-gray-40" />
            ) : isPublishedGreaterThanStaged ? (
              <ArrowUp size={16} className="text-yellow-60" />
            ) : (
              <ArrowDown size={16} className="text-yellow-60" />
            ))}
          <Text as="div" className="ml-2">
            {stagedValue}
          </Text>
        </div>
      </ColumnCard>
    </div>
  );
};

export default ComparisonRow;
